module.exports = __webpack_public_path__ + "static/media/22.776125f2.jpg";